/**
 * Safely opens a print window with HTML content.
 * Uses DOM methods instead of document.write() to prevent XSS.
 */
export const safePrintWindow = (title, htmlContent) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;
  
  const doc = printWindow.document;
  doc.open();
  doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + escapeHtml(title) + '</title></head><body></body></html>');
  doc.close();
  
  const container = doc.createElement('div');
  container.innerHTML = htmlContent;
  doc.body.appendChild(container);
  
  setTimeout(() => printWindow.print(), 300);
  return printWindow;
};

/**
 * Escape HTML special characters to prevent XSS in print templates.
 */
export const escapeHtml = (str) => {
  if (!str) return '';
  const s = String(str);
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

/**
 * Build a print-ready HTML string with clinic header.
 * Data values are escaped, structure is controlled.
 */
export const buildPrintHtml = (styles, bodyHtml) => {
  return `<style>${styles}</style>${bodyHtml}`;
};
